module.exports = __webpack_public_path__ + "img/item-8.04310850.png";